import React from "react";
import "./hero.css";
import Globe from "../../../../../assets/images/globe.jpg";
import CtaArrow from "../../../../../assets/images/arrow-cta.svg";
import Lottie from "react-lottie-player";
import lottieJson from "../../../../../assets/images/apis.json";
import { Link, useNavigate } from "react-router-dom";
import { IsAuthenticated } from "helpers";
function Hero() {
  const navigate = useNavigate();
  let offset = 100;
  const scrollToAPI = () => {
    window.scrollTo({
      behavior: "smooth",
      top:
        document.getElementById("api-offerings").getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        offset,
    });
  };

  return (
    <>
      <img
        className="globe-bg"
        src={Globe}
        alt="The Next-Generation API Platform"
      />
      <div className="wrap-hero d-flex align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="left-wrap">
                <h1 className="hero-title">
                  The <span>Next-Generation</span> <br /> API Platform
                </h1>
                <p className="hero-desc">
                  Connect with apps and build services with our <br />
                  easy-to-use APIs
                </p>
                {IsAuthenticated() ? (
                  <button
                    className="btn btn-vct"
                    type="button"
                    onClick={() => {
                      navigate("/dashboard");
                    }}
                  >
                    Get API Keys <img src={CtaArrow} alt="Get API Keys" />
                  </button>
                ) : (
                  <button
                    className="btn btn-vct"
                    type="button"
                    onClick={() => {
                      navigate("/authentication/sign-up");
                    }}
                  >
                    Get API Keys <img src={CtaArrow} alt="Get API Keys" />
                  </button>
                )}
              </div>
            </div>
            <div className="col-md-6 text-center">
              <div className="wrap-api">
                <Lottie loop controls={true} animationData={lottieJson} play />
              </div>
            </div>
          </div>
          <div className="row">
            <Link
              to="#api-offerings"
              className="scroll-down-animation"
              onClick={scrollToAPI}
            >
              <span className="mouse">
                <span className="move"></span>
              </span>
              <h2 className="sroll-more">Scroll to see more</h2>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Hero;
